import React, { useState } from 'react';
import { View, Text } from 'react-native';
import { FormattedMessage } from 'react-intl';
import HeaderDefault from '../../components/HeaderDefault';
import Button from '../../components/Button';
import MaskedInputDefault from '../../components/Form/MaskedInputDefault';

import styles from './styles';

const IdentityDocumentPix = () => {
    const [document, setDocument] = useState('');
    return (
        <>
            <HeaderDefault title={<FormattedMessage id='identityDocumentPix.cpfCnpj'/>} />

            <View style={styles.container}>
                <View style={styles.contentDocument}>
                    <FormattedMessage id='identityDocumentPix.placeholderCpfCnpj'>
                        {placeholder =>
                        <MaskedInputDefault
                            mask={document.length <= 14 ? "999.999.999-99" : "99.999.999/9999-99"}
                            keyboardType="numeric"
                            value={document}
                            onValueChange={(value) => setDocument(value)}
                            placeholder={placeholder}
                        />}
                        </FormattedMessage>
                </View>

                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='identityDocumentPix.valorTransferencia'/></Text>
                    <Text><FormattedMessage id='identityDocumentPix.valorTransferenciaBrl'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='identityDocumentPix.moeda'/></Text>
                    <Text><FormattedMessage id='identityDocumentPix.ValorTransferenciaGpx'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='identityDocumentPix.ValorDoDia'/></Text>
                    <Text><FormattedMessage id='identityDocumentPix.ValorDoDiaGpx'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='identityDocumentPix.txtRecebedor'/></Text>
                    <Text><FormattedMessage id='identityDocumentPix.txtNome'/></Text>
                </View>
            </View>

            <Button route={"ConfirmPassword"} text={<FormattedMessage id='identityDocumentPix.btnContinuar'/>} titlePage={<FormattedMessage id='identityDocumentPix.btnContinuaTransferencia'/>} />
        </>
    );
}

export default IdentityDocumentPix;